// extracted by mini-css-extract-plugin
module.exports = {"lineThrough":"OBTComplete_lineThrough__bluYh","arrowBtn":"OBTComplete_arrowBtn__24wzd"};